import { circularProgressClasses } from '@mui/material/CircularProgress'
import ContainerLoader from '@/components/LoaderContainer/ContainerLoader'
import { IND_COLOURS } from '@/constants/streamEvents/constants'

const ProvisionedIndicator = () => {
  return (
    <div
      style={{
        width: '20px',
        height: '20px',
        marginRight: '20px',
        borderRadius: '50%',
        backgroundColor: 'green'
      }}
    />
  )
}

const UnprovisionedIndicator = () => {
  return (
    <div
      style={{
        width: '20px',
        height: '20px',
        marginRight: '20px',
        borderRadius: '50%',
        backgroundColor: 'red'
      }}
    />
  )
}

const ProvisioningIndicator = () => {
  return (
    <>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor={IND_COLOURS.ORANGE} />
            <stop offset="100%" stopColor="#FFCB00" />
          </linearGradient>
        </defs>
      </svg>
      <ContainerLoader
        sx={{
          'svg circle': { stroke: 'url(#my_gradient)' },
          marginRight: '20px',
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round'
          }
        }}
        thickness={8}
        size={20}
      />
    </>
  )
}

export { ProvisionedIndicator, ProvisioningIndicator, UnprovisionedIndicator }
